import { I18n } from 'react-i18nify-lite'

export const required = value => value ? undefined : I18n.t('common.required');

const requiredNumber = value => value === '' ? I18n.t('common.required') : undefined;

const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
        I18n.t('common.invalidEmail') : undefined;

const minValue = min => value => {
    if (!value && value !== 0) {
        // exit if there is no value. This solution needed, because when value is 0, "value && ..." returns False
        return undefined
    }
    return Number(value) < min ? I18n.t("formValidator.minValue", { min }) : undefined;
};

const maxValue = max => value => value && Number(value) > max ? 'Max Value ' + max : undefined;


const maxLength = max => value =>
    value && value.length > max ? I18n.t("formValidator.maxLength", { max }) : undefined;

const requiredArray = value =>
    value && value.length === 0 ? I18n.t("common.required") : undefined;

const validInteger = value =>
    Number.isInteger(Number(value)) ? undefined : I18n.t('formValidator.validInteger');


const minValue1 = minValue(1);
const maxValuePython = maxValue(2147483647);

const formNumberMin1 = value => {
    let res = undefined;
    const validators = [requiredNumber, minValue1, maxValuePython, validInteger, required];

    validators.forEach(validator => {
        if (res === undefined) {
            res = validator(value)
        }
    });
    return res;
};

const requiredIPValidator = (fieldValue) => {
    if (fieldValue === '') {
        return I18n.t('common.required');
    }
};

const alphanumericPlus = value =>
    {
    return !/^[a-z][a-z0-9._-]*$/i.test(String(value)) ?
        I18n.t('common.invalidName') : undefined;
    };


const validator = {
    required,
    requiredNumber,
    email,
    maxValue,
    maxValuePython,
    minValue,
    minValue1,
    maxLength,
    requiredArray,
    validInteger,
    formNumberMin1,
    alphanumericPlus,
    requiredIPValidator
}

export default validator;